import { LabelSlots } from './LabelSlots.js';
export default LabelSlots;
//# sourceMappingURL=index.js.map